import { _lcs } from "../i18n";

/**
 * Wording for the hard-deletion dialogs (core-api PurgeService previews:
 * GET /admin/accommodation/:id/purge, GET /admin/user/:userId/purge).
 * Shared by "Unterkünfte" and "Gastgeber" so both name the same things the
 * same way. Only what exists is listed.
 */

// Preview key → German source string with a {count} slot (dictionary key).
const KINDS = [
    [ "guestbookBlocks", "{count} Gästemappe-Module" ],
    [ "events", "{count} eigene Veranstaltungen" ],
    [ "places", "{count} eigene Orte" ],
    [ "tours", "{count} eigene Touren" ],
    [ "conversations", "{count} Chat-Verläufe mit Gästen" ],
    [ "surveys", "{count} Umfragen" ],
    [ "surveyAnswers", "{count} Umfrage-Antworten" ],
    [ "plans", "{count} Reisepläne von Gästen" ],
    [ "pushSubscriptions", "{count} Push-Abonnements" ],
    [ "pushMessages", "{count} Push-Nachrichten" ],
    [ "conciergeDocuments", "{count} Concierge-Dokumente" ],
    [ "guests", "{count} Gast-Verknüpfungen" ],
    [ "guestAccounts", "{count} Gastkonten ohne weitere Unterkunft" ]
];

/** "• 3 Gästemappe-Module" lines for one accommodation preview. */
export function purgeLines( preview )
{
    return KINDS
        .filter( ( [ key ] ) => +( preview && preview[ key ] ) > 0 )
        .map( ( [ key, label ] ) => "• " + _lcs( label, { count : +preview[ key ] } ) );
}

/** Sum the counts of several accommodation previews (a host's houses). */
export function sumPreviews( previews )
{
    const total = {};
    ( previews || [] ).forEach( ( p ) =>
    {
        KINDS.forEach( ( [ key ] ) => { total[ key ] = ( total[ key ] || 0 ) + ( +p[ key ] || 0 ); } );
    } );
    return total;
}
